import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "className", "name", "title", "caption", "required", "setValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import dayjs from "@/lib/day";
import formStyles from "@/styles/Form.module.scss";
import paymentMethodStyles from "@/styles/PaymentMethod.module.scss";
import classnames from "classnames";
import merge from "deepmerge";
import { forwardRef, useCallback, useEffect, useReducer } from "react";
import SelectField from "./SelectField";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function createOption(value, format) {
  var valueWithZero = value < 10 ? "0" + value : String(value);
  return {
    value: valueWithZero,
    label: "".concat(value).concat(format)
  };
}

function yearOptions() {
  var now = dayjs();
  var year = now.year();
  var maxYear = year + 15;
  var options = [];

  var _iterator = _createForOfIteratorHelper(Array(maxYear - year + 1).keys()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var i = _step.value;
      var value = year + i;
      options.push(createOption(value, "年"));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return options;
}

function monthOptions() {
  var options = [];

  var _iterator2 = _createForOfIteratorHelper(Array(12).keys()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var i = _step2.value;
      var value = i + 1;
      options.push(createOption(value, "月"));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return options;
}

var initialState = {
  expirationDate: "",
  year: "",
  month: ""
};
var ExpirationDateField = /*#__PURE__*/forwardRef(function (props, ref) {
  var error = props.error,
      className = props.className,
      name = props.name,
      title = props.title,
      caption = props.caption,
      required = props.required,
      setValue = props.setValue,
      _props = _objectWithoutProperties(props, _excluded);

  var customStylesMonth = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: "5em"
      });
    },
    input: function input(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: "0",
        paddingBottom: "0px",
        paddingTop: "0px",
        color: "#666",
        width: "3em"
      });
    }
  };
  var customStylesYear = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: "6.8em"
      });
    }
  };
  var reducer = useCallback(function (state, action) {
    var newState = _objectSpread({}, state);

    switch (action.type) {
      case "year":
        return merge(newState, {
          year: action.value,
          expirationDate: "".concat(action.value).concat(state.month)
        });

      case "month":
        return merge(newState, {
          month: action.value,
          expirationDate: "".concat(state.year).concat(action.value)
        });

      default:
        return state;
    }
  }, []);

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var handleYearChange = useCallback(function (option) {
    dispatch({
      type: "year",
      value: option.value
    });
  }, []);
  var handleMonthChange = useCallback(function (option) {
    dispatch({
      type: "month",
      value: option.value
    });
  }, []);
  var handleBlur = useCallback(function () {
    var input = document.querySelector("input[name=".concat(name, "]"));
    input.dispatchEvent(new Event("blur"));
  }, []);
  useEffect(function () {
    setValue(name, state.expirationDate);

    if (state.expirationDate.length > 0) {
      var input = document.querySelector("input[name=".concat(name, "]"));
      input.dispatchEvent(new Event("input", {
        bubbles: true
      }));
    }
  }, [state.expirationDate]);
  return /*#__PURE__*/_jsxs("div", {
    className: formStyles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(formStyles.formTitle, _defineProperty({}, formStyles.required, required)),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentMethodStyles.expirationDateFieldPair,
      children: [/*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: "".concat(name, "-m"),
        placeholder: "\u6708",
        options: monthOptions(),
        onChange: handleMonthChange,
        onBlur: handleBlur,
        customStyles: customStylesMonth,
        className: formStyles.selectMonth
      }, _props)), /*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: "".concat(name, "-y"),
        placeholder: "\u5E74",
        options: yearOptions(),
        onChange: handleYearChange,
        onBlur: handleBlur,
        customStyles: customStylesYear
      }, _props))]
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      ref: ref,
      name: name,
      value: state.expirationDate
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    }), caption && /*#__PURE__*/_jsx("p", {
      className: formStyles.caption,
      children: caption
    })]
  });
});
ExpirationDateField.displayName = "ExpirationDateField";
export default ExpirationDateField;